import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';

export const Container = styled.div`
  margin: 0 32px 100px;
  border-top: 1px solid ${COLORS.ALTO};
  border-bottom: 1px solid ${COLORS.ALTO};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(50vh);
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  font-weight: 500;
  text-align: left;
  text-transform: uppercase;

  ${media.mobile} {
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.02em;
  }

  ${media.tablet} {
    margin: 0 50px;
  }
`;
